import React, { Component } from 'react'

import config from '../config'
import utils from '../utils'
const { $, priceFormat, FE } = utils,{ pvIds } = config

export default class ShopItem extends Component {
  constructor(props){
    super(props)
    this.state = {
      couponSum: 0
    }
    this.getCoupon = this.getCoupon.bind(this)
  }

  getCoupon(){
    let _this = this
    $.ajax({
      url: `//coupon.mall.autohome.com.cn/coupon/getList`,
      data: {
        platform: FE.APP.IS_APP?8:2,
        providerId: this.props.shop.deliveryProviderId
      },
      dataType: 'jsonp',
      success: function(data){
        if(data.success && data.result && data.result.length){
          _this.setState({couponSum: data.result[0].couponSum})
        }
      }
    })
  }

  componentDidMount(){
    this.getCoupon()
  }

  render() {
    let { shop, isLast, index } = this.props,{ items } = shop,{ couponSum } = this.state
    return(
      <div className={items.length === 3?'':'fn-hide'}>
        <a href={FE.Utils.getHref(`${shop.shopMUrl}#pvareaid=${pvIds.shop}`)} className='shop-link'>
          <img className='shop-img' src={shop.shopLogoUrl} alt=""/>
          <p className='shop-name'>{shop.providerName}</p>
          <p className='shop-btn'>{couponSum?`${couponSum}元红包`:'进入店铺'}</p>
        </a>
        <div className={`shop-right shop-right--${index}`}></div>
        <div className='shop-wrap' style={isLast?{'marginBottom': '0.1rem'}:{}}>
          {
            items.map(item => 
              <a href={FE.Utils.getHref(`${item.itemDetailUrl || item.mDetailUrl}#pvareaid=${pvIds.shopGoods}`)} className='shop-carItem' key={Math.random()}>
                <div className='shop-carItem-box'>
                  <img src={item.itemUrl || item.picUrl} alt=""/>
                </div>
                <p className='shop-carItem-name'>{item.itemName || item.name}</p>
                <p className='shop-carItem-price'><span>{priceFormat(item.itemPrice || item.price)}</span>万</p>
              </a>
            )
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ShopItem.js